import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import Select, { Async } from "react-select";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Row, Col, FormGroup, Label, FormFeedback, Input } from "reactstrap";
import axios from "axios";
import DatePicker from "react-widgets/DatePicker";
import "react-widgets/styles.css";
import Moment from 'moment-timezone';
import parse from 'html-react-parser';

import classes from "./EditRemovalModal.module.scss";
import Form from "./../../../general/Form/Form";

const config = {
  headers: {
    "Content-Type": "application/json"
  },
  withCredentials: true
};

const initialState = {
  license_plate: "",
  truck_name: "",
  truck_id: "",
  vendor_name: "",
  vendor_id: "",
  payment_schedule_id: "",
  payment_schedule_end_date: "",
  removal_complete: "",
  removed_date: "",
  removal_notes: "",
  removal_img_url: "",
  payment_schedule_needs_truncation : false,
  user_entered_removal_date: false,
  loadedRemovalData: false,
};

class EditRemovalModal extends Component{

  state=initialState;

  componentDidUpdate = async () => {
      this.fetchModalData();
  };

  componentWillReceiveProps (nextProps){
    //this.fetchModalData();
    if (nextProps.data.id === this.state.truck_id && nextProps.show === this.props.show){
    }
    else {
      this.setState(initialState);
      this.fetchModalData();
    }

  }

  fetchModalData = async () => {
    if (this.props.edit && this.props.data && !this.state.loadedRemovalData){
      let res = await axios.get(
        `${process.env.REACT_APP_API_HOST}/removal/${this.props.data.id}`,
        { withCredentials: true }
      )
      .then((response) => {
        let rawData = response.data.removal.rows[0];
        this.setState({
          loadedRemovalData: true,
          license_plate: rawData.license_plate,
          truck_name: rawData.truck_name,
          truck_id: rawData.truck_id,
          vendor_name: rawData.vendor_name,
          vendor_id: rawData.vendor_id,
          campaign_name: rawData.campaign_name,
          payment_schedule_id: rawData.payment_schedule_id,
          payment_schedule_end_date: rawData.payment_schedule_end_date,
          removal_complete: rawData.removal_complete,
          removed_date: rawData.removed_date,
          removal_notes: rawData.removal_notes ? rawData.removal_notes : '',
          removal_img_url: rawData.removal_img_url,
        });

      });
    }


  };

  onFormSubmitHandler = async (e) => {
    e.preventDefault();
    let removalData = {
      removal_id: this.props.data.id,
      removal_complete: this.state.removal_complete,
      removal_notes: this.state.removal_notes,
      removal_img_url: this.state.removal_img_url,
      removal_date: this.state.removed_date,
      truncate_payment_schedule: this.state.payment_schedule_needs_truncation,
      payment_schedule_id: this.state.payment_schedule_id,
    }
    let res = await axios.put(
      `${process.env.REACT_APP_API_HOST}/removal/${this.props.data.id}`, removalData, { withCredentials: true })
    .then((response) => {
      this.props.toggleHandler(true);
    })
    .catch((err) => {
      console.log(err);
      this.props.toggleHandler(true);
    });
  }

  buildTruckString() {
    return this.state.truck_name + " ("+ this.state.license_plate + ")";
  }
  buildPaymentScheduleString(){
    return this.state.payment_shedule_id + " (End date: " + Moment.utc(this.state.payment_schedule_end_date).format("MM/DD/YYYY") + ")";
  }
  removalNotesChangeHandler = (e) =>{
    this.setState({
      removal_notes: e.target.value,
    });
  }

  saveAndMarkRemovedHandler = async (e) =>{
    let payment_schedule_needs_truncation = false;
    let newNotes = this.state.removal_notes;

    if (Moment(this.state.removed_date).diff(Moment.utc(this.state.payment_schedule_end_date), 'days') <0){
      let confirmString = "The payment schedule end date for this truck was " + Moment.utc(this.state.payment_schedule_end_date).format("MM/DD/YYYY") + ". \
      \n if you mark this truck as removed on " + Moment(this.state.removed_date).format("MM/DD/YYYY") + ", the payment schedule will be terminated " +Moment.utc(this.state.payment_schedule_end_date).diff(Moment(this.state.removed_date), 'days') + " days before scheduled. Proceed?";
      if (! window.confirm(confirmString)){
        return;
      }
      payment_schedule_needs_truncation = true;
      newNotes = newNotes + "\nOn " + Moment().format("MM/DD/YYYY") +", the payment schedule's end date was updated from " + Moment.utc(this.state.payment_schedule_end_date).format("MM/DD/YYYY") + " to " + Moment(this.state.removed_date).format("MM/DD/YYYY");
    }

    this.setState({
      removal_complete: true,
      payment_schedule_needs_truncation: payment_schedule_needs_truncation,
      removal_notes: newNotes,
    }, () => this.onFormSubmitHandler(e));
  };

  reopenRemovalHandler = async (e) =>{
    this.setState({
      removal_complete: false,
      removed_date: null,
    }, () => this.onFormSubmitHandler(e));
  };
  removedDateChangeHandler = (date) =>{
    console.log("Date: " + Moment.utc(date));
    this.setState({
      removed_date: Moment.utc(date),
      user_entered_removal_date: true,
    });
  };

  render() {
    const style = {
      padding: "15px 20px"
    };
    const formStyle = {
      boxShadow: "none"
    };

    return (
      <Modal isOpen={this.props.show} toggle={() => this.props.toggleHandler(false)} className="modal-xl">
        <ModalHeader toggle={() => this.props.toggleHandler(false)}>{this.props.removal_complete ? "Review Past Removal" : this.props.title}</ModalHeader>
        <ModalBody>
          <Form sectionStyle={{ boxShadow: "none" }} formStyle={style}>
            <div style={{ "width" : "100%" }}>
              <Row>
                <Col md={6}>
                  <Row form className="mb-4 pt2">
                    <Label className="removal-modal-label" for="truck_id">Truck: </Label>
                    <Input
                    type="text"
                    value={this.buildTruckString()}
                    readOnly={true}
                    id="truck_id"
                    />
                    <Label className="removal-modal-label">Vendor: </Label>
                    <Input
                    type="text"
                    value={this.state.vendor_name}
                    readOnly={true}
                    />
                    <Label className="removal-modal-label">Payment Schedule End Date:</Label>
                    <Input
                    type="text"
                    value={Moment.utc(this.state.payment_schedule_end_date).format("MM/DD/YYYY")}
                    readOnly = {true}
                    />
                    <Label className="removal-modal-label">Campaign Name:</Label>
                    <Input
                    type="text"
                    value={this.state.campaign_name}
                    readOnly={true}
                    />
                  </Row>
                </Col>

                <Col md={6}>
                  <FormGroup>
                    <Row form className="mb-4">
                      <Label className="modal-label">Removal Notes: </Label>
                      <Input
                        type="textarea"
                        value={this.state.removal_notes}
                        onChange={this.removalNotesChangeHandler}
                        readOnly={this.state.removal_complete}
                        />
                    </Row>

                    <Row form className="mb-1">
                      <Label className="removal-modal-label">Days Left on Payment Schedule:</Label>
                    </Row>

                    <Row form className="mb-4">
                      <Col md={3}>
                        <Input
                          type="text"
                          bsSize="lg"
                          value={''+Moment(this.state.payment_schedule_end_date).diff(Moment.utc(), 'days')}
                          readOnly={true}
                        />
                      </Col>
                    </Row>

                    <Row form className="mb-1">
                      <Label className="removal-modal-label">Actual Removal Date: </Label>
                    </Row>

                    <Row form className="mb-4">
                      <DatePicker
                        value={this.state.removed_date ? new Date(this.state.removed_date) : null}
                        valueFormat={{ dateStyle: "medium" }}
                        readOnly={this.state.removal_complete ? true : false}
                        onChange={date => this.removedDateChangeHandler(date)}
                      />
                    </Row>
                  </FormGroup>
                </Col>
              </Row>
            </div>
          </Form>
        </ModalBody>
        {this.state.removal_complete && (
          <ModalFooter>
            <div className = {classes.footer_message}>{parse("This removal was completed on: " + Moment(this.state.removed_date).format("MM/DD/YYYY") + "<br >To make changes you must reopen this removal.")}</div>
            <Button color="warning" onClick = {this.reopenRemovalHandler}>
            Reopen
            </Button>
            <Button color="secondary" onClick={() => this.props.toggleHandler(false)}>
            Cancel
            </Button>
          </ModalFooter>
        )}

        {this.state.removal_complete === false && this.state.user_entered_removal_date === false && (
          <ModalFooter>
            <Button color="primary" onClick={this.onFormSubmitHandler}>
            Save
            </Button>
            <Button color="secondary" onClick={() => this.props.toggleHandler(false)}>
            Cancel
            </Button>
          </ModalFooter>
        )}
        {this.state.removal_complete ===false && this.state.user_entered_removal_date && (
          <ModalFooter>
            <Button color="danger" onClick={this.saveAndMarkRemovedHandler}>
            Save & Mark Removed
            </Button>
            <Button color="secondary" onClick={() => this.props.toggleHandler(false)}>
            Cancel
            </Button>
          </ModalFooter>
        )}
      </Modal>
    );
  }
}
export default EditRemovalModal;
